import classNames from 'classnames'
import { type INameValueRecordProps, NameValueRecord, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import styles from '../styles.module.scss'

export const SendFromListContent = ({
  list,
  name,
  hideBorder,
  label,
}: {
  list: INameValueRecordProps[]
  name: string
  hideBorder?: boolean
  label: string
}) => (
  <div>
    <div className={styles.grid}>
      <Typography ariaLabel='Send' variant='text-input-field' className={styles.label}>
        {label}
      </Typography>
      <div className={styles.listWrap}>
        {list.map((data, index) => {
          return (
            <div
              className={classNames(styles.listValue, {
                [styles.hideBorder]: hideBorder,
              })}
              key={index}
              aria-label={getAriaLabel('SendFromListContent')}
            >
              <NameValueRecord ariaLabel={`${name}DetailsNumber`} {...data} />
            </div>
          )
        })}
      </div>
    </div>
  </div>
)
